import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import apolloProvider from "@/plugins/vue-apollo";
import "@/plugins/element";
import "@/assets/css/tailwind.css";
import "@/assets/css/base.css";

import ToastMixin from "@/mixins/toast";
import FormMixin from "@/mixins/form";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";

Vue.mixin(ToastMixin);
Vue.mixin(FormMixin);
Vue.use(require("vue-moment"));
Vue.use(Chartkick.use(Chart));

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount("#app");
